import _styled from "styled-components";
import React from 'react';
import { SolidButtonLink } from '@noths/polaris-client-ribbons-design-system';
import * as styles from "./PreviewHeader.styles";
export var PreviewHeader = function PreviewHeader(_ref) {
  var href = _ref.href;
  return /*#__PURE__*/React.createElement(_StyledHeader, {
    $_css: styles.container
  }, /*#__PURE__*/React.createElement(SolidButtonLink, {
    compact: true,
    href: href
  }, "Exit Preview"));
};
var _StyledHeader = /*#__PURE__*/_styled("header").withConfig({
  displayName: "PreviewHeader___StyledHeader",
  componentId: "sc-6v4d45-0"
})(["", ""], function (p) {
  return p.$_css;
});